import React from 'react';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import DropdownContainer from '../../containers/DropdownContainer';
import { useSelector } from 'react-redux';

const MarketingReportingPlatformPageDropdowns = ({ platform }) => {

  const startDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
  const endDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    return (
          <GenericReportingDropdowns
            includeDateRange={true}
            includeGranularity={true}
            includeTooltipsAndTitles={false}
            containerStyle="dropdown-container"
            renderAsButton={true}
            includeCompareDateRange={true}
            extraDropdowns={
                <>
                    <DropdownContainer dropdown_name="selected_campaigns" preserveUserSelections={false} extraApiParams={{
                      platform: platform,
                      start_date: startDate,
                      end_date: endDate
                    }} />
                    <DropdownContainer dropdown_name="selected_campaign_types" preserveUserSelections={false} extraApiParams={{
                      platform: platform,
                      start_date: startDate,
                      end_date: endDate
                    }} />
                </>
            }
          />
    );
};

export default MarketingReportingPlatformPageDropdowns;